import { tv } from 'tailwind-variants'

import { body2, caption } from '@ui-kit/core/typography'

export const itemActionRow = tv({
  slots: {
    container: 'flex-row items-center gap-4',
    tile: 'h-16 w-16 items-center justify-center rounded-[12px] bg-grey-100',
    textContainer: 'flex-1',
    title: body2({ weight: 'semibold' }),
    subtitle: caption({ color: 'grey500' }),
    action: 'flex-row items-center gap-1 rounded-full bg-grey-200 px-2 py-[5px]',
    actionLabel: caption({ bold: true }),
  },
  variants: {
    disabled: {
      true: { action: 'opacity-40' },
    },
  },
})
